import React from 'react';
import TextFilter from 'react-bootstrap-table/lib/filters/Text';
import { Glyphicon } from 'react-bootstrap';

class ReactBootstrapTableTextFilter extends TextFilter {
  render() {
    return (<div className={'column-filter-input'}>
      <span
        className={'column-filter-input-text'}
      >{super.render()}
      </span>
      <span
        className={'column-filter-input-addon'}
      >
        <Glyphicon glyph="search" />
      </span>
    </div>);
  }
}
export const getTextFilter = (filterHandler, customFilterParameters) =>
  <ReactBootstrapTableTextFilter
    filterHandler={filterHandler}
    columnName={customFilterParameters.columnName}
  />;
